/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import React, { useEffect, useRef, useState } from 'react';
import { DndContext, closestCenter, useSensor, useSensors, PointerSensor } from '@dnd-kit/core';
import { SortableContext, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useLocation } from 'react-router';

const initialBoxes = [
  { id: '1', width: 680, height: 155, top: 5, left: 10 },
  { id: '2', width: 300, height: 680, top: 170, left: 10 },
  { id: '3', width: 370, height: 270, top: 580, left: 320 },
  { id: '4', width: 370, height: 400, top: 170, left: 320 }
];

const SortableBox = ({ id, width, height, top, left }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
  const innerdiv = useRef();
  const location = useLocation();
  const componentProps = location.state?.componentProps || {};
  const [summary, setSummary] = useState(componentProps.summary);
  const [work_history, setWork_history] = useState(componentProps.work_history);
  const [education, setEducation] = useState(componentProps.education);
  const [skills, setSkills] = useState(componentProps.skills);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    width: `${width}px`,
    minHeight: `${height < innerdiv?.current?.style?.height ? innerdiv?.current?.style?.height : height}px`,
    position: 'absolute',
    top: `${top}px`,
    left: `${left}px`,
    display: 'flex',
    // alignItems: 'center',
    justifyContent: 'center',
    cursor: 'grab',
    border: '2px solid black',
    zIndex: transform ? 9999 : 'auto'
  };

  return (
    <div ref={setNodeRef} style={{ ...style, display: 'flex' }} {...attributes} {...listeners}>
      <div ref={innerdiv} style={{ overflow: 'visible' }}>
        {id == 1 && (
          <div>
            <h2>Your Name</h2>
            {summary}
          </div>
        )}
        {id == 2 && (
          <div style={{ alignItems: 'flex-start' }}>
            <h2>Work History</h2>
            <ul style={{ textAlign: 'left' }}>
              {work_history.map((work, index) => (
                <li key={index}>{work}</li>
              ))}
            </ul>
          </div>
        )}
        {id == 3 && (
          <div>
            <h2>Education</h2>
            {education}
          </div>
        )}
        {id == 4 && (
          <div style={{ textAlign: 'flex-start' }}>
            <h2>Skills</h2>
            <ul style={{ textAlign: 'left' }}>
              {skills.map((sks, index) => (
                <li key={index}>{sks}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

const DragSwapBoxes = () => {
  const [boxes, setBoxes] = useState(initialBoxes);
  useEffect(() => {}, [boxes]);

  const sensors = useSensors(useSensor(PointerSensor));
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id == 1 || active.id == 2 || over.id == 1 || over.id == 2) {
      return;
    } else if (over && active.id !== over.id) {
      const activeBox = boxes.find((box) => box.id === active.id);
      const overBox = boxes.find((box) => box.id === over.id);
      const newBoxes = boxes.map((box) => {
        if (box.id === active.id) {
          return { ...box, top: overBox.top === 170 ? 170 : overBox.top + (overBox.height - activeBox.height), left: overBox.left };
        } else if (box.id === over.id) {
          return { ...box, top: activeBox.top === 170 ? 170 : activeBox.top + (activeBox.height - overBox.height), left: activeBox.left };
        }
        return box;
      });

      setBoxes(newBoxes);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
      <div
        style={{
          width: '700px',
          height: '860px',
          border: '1px solid black',
          position: 'relative'
        }}
      >
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
          <SortableContext items={boxes}>
            {boxes.map((box) => (
              <SortableBox key={box.id} {...box} />
            ))}
          </SortableContext>
        </DndContext>
      </div>
    </div>
  );
};

export default DragSwapBoxes;
